import { useStore } from 'effector-react'

import { $sellPayouts, $totalCountOfSellPayouts, getSellPayoutList, sellPayoutListMounted, } from './model'
import { SellPayoutRequest } from "./types";

export const useSellPayoutList = () => {
  const onChangeSellPayoutList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: SellPayoutRequest) => {
    sellPayoutListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const sellPayouts = useStore($sellPayouts)
  const totalCountOfSellPayouts = useStore($totalCountOfSellPayouts)
  const loading = useStore(getSellPayoutList.pending)
  return {
     sellPayouts,
    totalCountOfSellPayouts,
    loading,
     onChangeSellPayoutList,
  }
}
